import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then((choice) => {
      console.log("Install outcome:", choice.outcome);
      setDeferredPrompt(null);
    });
  };

  return (
    <AnimatePresence>
      {deferredPrompt && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-6 right-6 z-50 bg-white/90 backdrop-blur-md shadow-xl rounded-lg px-5 py-3 border border-gray-200 flex items-center gap-3"
        >
          <p className="text-gray-700 text-sm font-medium">
            Install this app for a better experience
          </p>
          <button
            onClick={handleInstall}
            className="bg-gradient-to-r from-pastel-blue-400 to-pastel-pink-400 text-white px-3 py-1 rounded-md text-sm font-semibold shadow hover:shadow-md transition"
          >
            Install
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
